import { render, staticRenderFns } from "./StudioList.vue?vue&type=template&id=5c752449&scoped=true&"
import script from "./StudioList.vue?vue&type=script&lang=js&"
export * from "./StudioList.vue?vue&type=script&lang=js&"
import style0 from "./StudioList.vue?vue&type=style&index=0&id=5c752449&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c752449",
  null
  
)

export default component.exports